import { default as authrFT4p3If81Meta } from "/app/src/pages/auth.vue?macro=true";
import { default as indexyL4L6aW4RlMeta } from "/app/src/pages/browsing/index.vue?macro=true";
import { default as indexLHyltbMNapMeta } from "/app/src/pages/cinema/archive/[channelId]/index.vue?macro=true";
import { default as indexbznpBqTB1gMeta } from "/app/src/pages/cinema/category/[categoryId]/index.vue?macro=true";
import { default as indexqQrbv73DcyMeta } from "/app/src/pages/cinema/index.vue?macro=true";
import { default as _91id_93hLY5cw1WRFMeta } from "/app/src/pages/container/[id].vue?macro=true";
import { default as indexLhKgQlf7JAMeta } from "/app/src/pages/favorite/index.vue?macro=true";
import { default as indexU60NJKHBjQMeta } from "/app/src/pages/history/index.vue?macro=true";
import { default as indexdPwi6hPdMfMeta } from "/app/src/pages/index.vue?macro=true";
import { default as indexEPualSkP22Meta } from "/app/src/pages/item/[id]/detail/index.vue?macro=true";
import { default as indexasvcxD4shBMeta } from "/app/src/pages/item/[id]/index.vue?macro=true";
import { default as indexryeyzVwzICMeta } from "/app/src/pages/live/index.vue?macro=true";
import { default as index2gRhQT9qIDMeta } from "/app/src/pages/search/index.vue?macro=true";
export default [
  {
    name: "auth",
    path: "/auth",
    component: () => import("/app/src/pages/auth.vue")
  },
  {
    name: "browsing",
    path: "/browsing",
    component: () => import("/app/src/pages/browsing/index.vue")
  },
  {
    name: "cinema-archive-channelId",
    path: "/cinema/archive/:channelId()",
    component: () => import("/app/src/pages/cinema/archive/[channelId]/index.vue")
  },
  {
    name: "cinema-category-categoryId",
    path: "/cinema/category/:categoryId()",
    component: () => import("/app/src/pages/cinema/category/[categoryId]/index.vue")
  },
  {
    name: "cinema",
    path: "/cinema",
    component: () => import("/app/src/pages/cinema/index.vue")
  },
  {
    name: "container-id",
    path: "/container/:id()",
    meta: _91id_93hLY5cw1WRFMeta || {},
    component: () => import("/app/src/pages/container/[id].vue")
  },
  {
    name: "favorite",
    path: "/favorite",
    component: () => import("/app/src/pages/favorite/index.vue")
  },
  {
    name: "history",
    path: "/history",
    component: () => import("/app/src/pages/history/index.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/app/src/pages/index.vue")
  },
  {
    name: "item-id-detail",
    path: "/item/:id()/detail",
    component: () => import("/app/src/pages/item/[id]/detail/index.vue")
  },
  {
    name: "item-id",
    path: "/item/:id()",
    component: () => import("/app/src/pages/item/[id]/index.vue")
  },
  {
    name: "live",
    path: "/live",
    component: () => import("/app/src/pages/live/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/app/src/pages/search/index.vue")
  }
]